<div class="form-group">
  <label *ngIf="label" part="label" class="font-weight-bold" [for]="labelId">
    {{ label }}<span *ngIf="required" class="user-select-none text-danger">&nbsp;*</span>
  </label>
  <textarea
    #textarea
    part="control"
    class="form-control"
    [id]="labelId"
    [value]="value"
    [attr.maxlength]="maxLength ?? null"
    [attr.touched]="touched ?? null"
    [attr.was-validated]="wasValidated ? true : null"
    [attr.invalid]="valid === false ? true : null"
    [attr.disabled]="disabled === true ? true : null"
    [attr.required]="required"
    (input)="onInput($event)">
  </textarea>
  <p *ngIf="validationMessage && wasValidated && valid === false" part="validation-message" class="form-text text-danger">
    {{ validationMessage }}
  </p>
  <small *ngIf="description" part="description" class="form-text text-muted">
    {{ description }}
  </small>
</div>
